const regionAnalyzer = (provider, planName) => {
    switch (provider) {
        case 'Airalo':
            return airaloRegionAnalyzer(planName)

        case 'Flexiroam':
            return flexiroamRegionAnalyzer(planName)

        case 'Nomad':
            return nomadRegionAnalyzer(planName)

        default:
            break;
    }
}

const airaloRegionAnalyzer = (planName) => {
    switch (true) {
        case planName.includes('Hello Africa'):
            return ('country.africa')

        case planName.includes('Latamlink'):
            return('country.latinAmerica')

        case planName.includes('Asialink'):
            return('country.asia')

        case planName.includes('Eurolink'):
            return ('country.greaterEurope')

        default:
            break;
    }
}

const flexiroamRegionAnalyzer = (planName) => {
    switch (true) {
        case planName.includes('Latin America'):
            return('country.latinAmerica')

        case planName.includes('Greater Europe'):
            return ('country.greaterEurope')

        case planName.includes('Europe'):
            return ('country.europe')

        case planName.includes('Africas'):
            return ('country.africa')

        case planName.includes('South East Asia'):
            return ('country.southEastAsia')

        case planName.includes('Greater China'):
            return ('country.greaterChina')

        case planName.includes('Americas'):
            return ('country.america')

        case planName.includes('Oceania'):
            return ('country.oceania')

        case planName.includes('Japan/Korea/Taiwan'):
            return ('country.japanKoreaTaiwan')

        default:
            break;
    }
}

const nomadRegionAnalyzer = (planName) => {
    switch (true) {
        case planName.includes('Europe'):
            return ('country.europe')

        case planName.includes('Nordic'):
            return ('country.nordic')

        case planName.includes('SEA-Oceania'):
            return ('country.seaOceania')

        case planName.includes('APAC'):
            return ('country.apac')

        case planName.includes('Global'):
            return ('country.global')

        default:
            break;
    }
}

export default regionAnalyzer;